"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SiteTemplates = exports.BuildingStatus = exports.FileTypes = exports.getEmptyBuilding = void 0;
var AmenitiesSpec = require("./amenitiesSpec");
var Help_1 = __importDefault(require("./Help")); //N.B. different paths, seems "@/ts/filenamewithoutextn" only works in .vue files 
var FileTypes;
(function (FileTypes) {
    FileTypes[FileTypes["img"] = 1] = "img";
    FileTypes[FileTypes["vid"] = 2] = "vid";
    FileTypes[FileTypes["xls"] = 3] = "xls";
    FileTypes[FileTypes["csv"] = 4] = "csv";
    FileTypes[FileTypes["pdf"] = 5] = "pdf";
    FileTypes[FileTypes["word"] = 6] = "word";
    FileTypes[FileTypes["ppt"] = 7] = "ppt";
    FileTypes[FileTypes["other"] = 8] = "other";
})(FileTypes || (FileTypes = {}));
exports.FileTypes = FileTypes;
var SiteTemplates;
(function (SiteTemplates) {
    SiteTemplates[SiteTemplates["unknown"] = 1] = "unknown";
    SiteTemplates[SiteTemplates["highEnd"] = 2] = "highEnd";
    SiteTemplates[SiteTemplates["lowEnd"] = 3] = "lowEnd";
})(SiteTemplates || (SiteTemplates = {}));
exports.SiteTemplates = SiteTemplates;
var BuildingStatus;
(function (BuildingStatus) {
    BuildingStatus[BuildingStatus["inProgress"] = 1] = "inProgress";
    BuildingStatus[BuildingStatus["saved"] = 2] = "saved";
    BuildingStatus[BuildingStatus["generating"] = 3] = "generating";
    BuildingStatus[BuildingStatus["awaitingPayment"] = 4] = "awaitingPayment";
    BuildingStatus[BuildingStatus["awaitingApproval"] = 5] = "awaitingApproval";
    BuildingStatus[BuildingStatus["publishing"] = 6] = "publishing";
    BuildingStatus[BuildingStatus["live"] = 7] = "live";
})(BuildingStatus || (BuildingStatus = {}));
exports.BuildingStatus = BuildingStatus;
var emptyBuildingSpec = {
    status: BuildingStatus.inProgress,
    details: {
        portfolioId: 0,
        portfolio: null,
        name: null,
        description: null,
        sqft: null
    },
    contacts: {
        facilitiesManagerId: null,
        facilitiesManagerContactId: null,
        clientAccountsContactId: null,
        creditControlContactId: null,
        facilitiesManager: null,
        clientAccounts: null,
        creditControl: null,
    },
    address: {
        postcode: null,
        text: null
    },
    location: {
        lat: null,
        lng: null,
    },
    serviceCharge: {
        value: null,
        fee: null,
        date: null,
    },
    amenities: {
        groups: AmenitiesSpec.amenityGroupData
    },
    visitorProcess: {
        openingHours24: null,
        openingHoursTimesText: null,
        openingHoursText: null,
        reception: null,
        reception24: null,
        receptionTimesText: null,
        receptionText: null,
        accessControlSystem: null,
        entryText: null,
        arrivalText: null,
    },
    files: {
        list: [],
        unassigned: [],
        websiteImagesAndVideos: [],
        tenantLogos: [],
        floorPlans: [],
        siteHandbooks: [],
        budgets: [],
        reconciliationPacks: []
    },
    tenants: {
        list: null,
        tenantsDetails: []
    },
    generate: {
        termsAccepted: null,
        poNumber: null,
        date: null,
    }
};
function getEmptyBuilding() {
    return Help_1.default.deepCloneObject(emptyBuildingSpec);
}
exports.getEmptyBuilding = getEmptyBuilding;
//# sourceMappingURL=buildingSpec.js.map